import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import "./HeroIntro.css";

import ampleLogo from "../../../Assets/logos/ample-house-logo.png";

const HeroIntro = ({ onComplete }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  const handleNavigate = () => {
    // optional: also trigger intro completion
    if (onComplete) onComplete();

    // navigate to main page
    navigate("/contact-us"); 
    // 👉 change to "/" if you want homepage instead
  };

  return (
    <div className="hero-intro">
      <div className="hero-intro-content">

        {/* Logo */}
        <motion.img
          src={ampleLogo}
          alt="Ample House"
          className="hero-intro-logo"
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1 }}
        />

        {/* Welcome */}
        <motion.h3
          className="hero-intro-small"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
        >
          WELCOME TO
        </motion.h3>

        {/* Main Brand */}
        <motion.h1
          className="hero-intro-title"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.2 }}
        >
          AMPLE HOUSE
        </motion.h1>

        {/* Tagline */}
        <motion.h2
          className="hero-intro-tagline"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 2 }}
        >
          WHERE LEADERSHIP IS BUILT
        </motion.h2>

        {/* CTA */}
        <motion.button
          className="hero-intro-button"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 3 }}
          onClick={handleNavigate}
        >
          Learn More About Ample House
        </motion.button>

      </div>
    </div>
  );
};

export default HeroIntro;